export const cores = [
    {
        id: 0,
        nome: "",
        value: "#FFFF00",
        color: "#FFFF00"
    },
    {
        id: 1,
        nome: "",
        value: "#FED800",
        color: "#FED800"
    },
    {
        id: 2,
        nome: "",
        value: "#FF9000",
        color: "#FF9000"
    },
    {
        id: 3,
        nome: "",
        value: "#FF4800",
        color: "#FF4800"
    },
    {
        id: 4,
        nome: "",
        value: "#FF0100",
        color: "#FF0100"
    },

    {
        id: 5,
        nome: "",
        value: "#B722B6",
        color: "#B722B6"
    },
    {
        id: 6,
        nome: "",
        value: "#7E0EAC",
        color: "#7E0EAC"
    },
    {
        id: 7,
        nome: "",
        value: "#7736FF",
        color: "#7736FF"
    },

    {
        id: 8,
        nome: "",
        value: "#005CFE",
        color: "#005CFE"
    },
    {
        id: 9,
        nome: "",
        value: "#01947B",
        color: "#01947B"
    },
    {
        id: 10,
        nome: "",
        value: "#0EC245",
        color: "#0EC245"
    },
    {
        id: 11,
        nome: "",
        value: "#89F629",
        color: "#89F629"
    }
]
